// extracted by mini-css-extract-plugin
export var childrenContainer = "_bo-0";